import { render } from "./PrefilUsuarioEmpresaView.vue?vue&type=template&id=509a7e26&ts=true"
import script from "./PrefilUsuarioEmpresaView.vue?vue&type=script&lang=ts"
export * from "./PrefilUsuarioEmpresaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__